import { Avatar, Flex, Text, Tooltip, VStack } from "@chakra-ui/react";
import { ReactNode, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { SCHEDULE_TYPES } from "../../../../common/constants/campaign";
import {
  checkIsAccountInactive,
  createUserMapping,
  getUserStatusFromMapping,
} from "../../../../common/helper/commonHelper";
import {
  UserListMap,
  USER_ACCOUNT_STATUS,
} from "../../../../common/types/auth";
import { FormatDate } from "../../../../components/DateTimeRangeFilter";
import { useAppDispatch } from "../../../../store";
import { getUserList, selectAccount } from "../../../account/accountSlice";
import { selectCampaign } from "../campaignSlice";

export default function CampaignDetails() {
  const {
    campaignDetails: { data: campaignDetails },
  } = useSelector(selectCampaign);
  const { usersList } = useSelector(selectAccount);
  const [userListMapping, sertUserListMapping] = useState<UserListMap>({});
  const dispatch = useAppDispatch();

  const userStatus: USER_ACCOUNT_STATUS = useMemo(
    () =>
      campaignDetails.created_by.id
        ? getUserStatusFromMapping(
            campaignDetails.created_by.id.toString(),
            userListMapping
          )
        : USER_ACCOUNT_STATUS.PENDING,
    [campaignDetails.created_by.id, userListMapping]
  );

  useEffect(() => {
    if (!usersList) {
      dispatch(getUserList());
    } else {
      let userListMap = createUserMapping(usersList);
      sertUserListMapping(userListMap);
    }
  }, [dispatch, usersList]);

  function Cell({ label, children }: { label: string; children: ReactNode }) {
    return (
      <VStack alignItems="left">
        <Text
          fontSize="14px"
          color="gray.300"
          fontWeight="bold"
          textTransform="uppercase"
        >
          {label}
        </Text>
        <Flex alignItems="center" fontSize="16px" fontWeight="bold">
          {children}
        </Flex>
      </VStack>
    );
  }

  const isUserInactive = checkIsAccountInactive(userStatus);
  if (campaignDetails.campaign_id)
    return (
      <VStack
        alignItems="left"
        spacing={6}
        pl={6}
        pt={4}
        borderLeft="1px solid"
        borderColor="gray.200"
      >
        <Cell label="journey published on">
          {campaignDetails.activated_at && (
            <FormatDate date={campaignDetails.activated_at} showTime />
          )}
        </Cell>
        <Cell label="created by">
          <Tooltip
            label="The user is inactive"
            fontSize="xs"
            position="initial"
            size="small"
            isDisabled={!isUserInactive}
          >
            <Flex alignItems="center">
              <Avatar
                mr={2}
                size="xs"
                name={campaignDetails.created_by.name}
                opacity={isUserInactive ? "0.5" : ""}
              />
              <Text color={isUserInactive ? "gray.300" : ""}>
                {campaignDetails.created_by.name}
              </Text>
            </Flex>
          </Tooltip>
        </Cell>
        <Cell label="schedule">
          {
            SCHEDULE_TYPES.find(
              (runType) => runType.value === campaignDetails.schedule?.run_type
            )?.name
          }
        </Cell>
      </VStack>
    );

  return <></>;
}
